import React from 'react'

const PageNotFound = () => {
  return (
    <div>
      <div className="extra-karge-title">404</div>
      Error : page not found

      by clicking here you can return back to the home page.
    </div>
  )
}

export default PageNotFound
